import {Outlet} from "react-router"


const SeoPages = () => {
  return <Outlet>pages list , settings</Outlet>

}
export default SeoPages